import { render, staticRenderFns } from "./SupplierTraining.vue?vue&type=template&id=64e6d7da&scoped=true&"
import script from "./SupplierTraining.vue?vue&type=script&lang=js&"
export * from "./SupplierTraining.vue?vue&type=script&lang=js&"
import style0 from "./SupplierTraining.vue?vue&type=style&index=0&id=64e6d7da&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64e6d7da",
  null
  
)

export default component.exports